export default __webpack_public_path__ + "static/media/conventus-5.52d3a34e.png";